module.exports = __webpack_public_path__ + "img/instagram.923e0b56.png";